import { Icon } from '@innovationnorway/cl-react';
import React from 'react';
import { useTranslation } from 'react-i18next';
type Props = {
  value: number;
  formattedValue?: string;
  hide?: boolean;
};
const BillSupportNumberHandler: React.FC<Props> = ({ value, formattedValue, hide = false }) => {
  const { t: tCommon } = useTranslation();
  if (hide) return <></>;
  if (Number.isNaN(value) || !isFinite(value)) {
    return (
      <div>
        <Icon prefix="fasr" iconName="triangle-exclamation" className="color--red margin-right--1" />{' '}
        {tCommon('invalidValue')}
      </div>
    );
  }
  if (value < 0) {
    return (
      <div>
        <Icon prefix="fasr" iconName="triangle-exclamation" className="color--red margin-right--1" />{' '}
        {formattedValue ? formattedValue : value}
      </div>
    );
  }
  return <span>{formattedValue ? formattedValue : value}</span>;
};
export default BillSupportNumberHandler;
